/*
 * Copyright (c) 2026 SimplyBook.me Ltd. All rights reserved.
 * Licensed under the Apache License, Version 2.0.
 */

import React from "react";
import { CART_LINE_TYPES } from "../constants/constants";
import MembershipMetadata from "../components/membership/MembershipMetadata";

export const cartRegistry = {
  [CART_LINE_TYPES.PRODUCT]: {
    mergeBy: (params) => `product:${params.product_id}`,
    canEditQty: true,
    buildSnapshot: (product) => ({
      id: product.id,
      name: product.name,
      price: product.price,
      currency: product.currency,
      picture: product.picture_path,
      description: product.description,
      duration: product.duration,
      tax: product.tax,
    }),
    renderMetadata: null,
  },
  [CART_LINE_TYPES.MEMBERSHIP]: {
    mergeBy: (params) => `membership:${params.membership_id}`,
    canEditQty: false,
    buildSnapshot: (membership) => ({
      id: membership.id,
      name: membership.name,
      price: membership.first_price,
      first_price: membership.first_price,
      currency: membership.currency,
      duration: membership.duration,
      duration_type: membership.duration_type,
      limit: membership.limit,
      is_unlimited: membership.is_unlimited,
      is_recurring: membership.is_recurring,
      recurring_price: membership.recurring_price,
      picture: membership.picture_preview,
      picture_path: membership.picture_preview,
      description: membership.description,
    }),
    renderMetadata: (item) => <MembershipMetadata item={item} />,
  },
  [CART_LINE_TYPES.PROMOTION]: {
    mergeBy: null,
    canEditQty: false,
    buildSnapshot: (promotion) => ({
      id: promotion.id,
      name: promotion.name,
      description: promotion.description,
      price: promotion.price,
      currency: promotion.currency,
      discount: promotion.discount,
      discount_type: promotion.discount_type,
      duration: promotion.duration,
      duration_type: promotion.duration_type,
      picture: promotion.picture_preview,
      tax: promotion.tax,
    }),
    renderMetadata: null,
  },
  [CART_LINE_TYPES.PACKAGE]: {
    mergeBy: null,
    canEditQty: false,
    buildSnapshot: (pkg) => ({
      id: pkg.id,
      name: pkg.name,
      price: pkg.price,
      currency: pkg.currency,
      picture: pkg.picture_path,
      description: pkg.description,
      duration: pkg.duration,
      duration_type: pkg.duration_type,
      tax: pkg.tax,
    }),
  },
};
